<div class = "body">

    <div *ngIf = "rol != 'ROLE_AFILIADO' && rol != 'ROLE_JUBILADO'">

        <div class = "container" style = "height:100px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-4"> <h1> Evaluación Postulantes </h1> </div>

                <div class = "col-lg-4"> </div>

                <div class = "col-lg-4" style = "text-align: center">  Presupuesto Total: {{presupuestoTotal  | currency:'CLP':'symbol-narrow' }} </div>

            </div> <hr/> <br/>

            <div class = "row">

                <div class = "col-lg-4"> <h3> Excelencia Académica </h3> </div>

                <div class = "col-lg-8"> </div>

            </div>

            <div class = "table-responsive">

                <table class = "table">

                    <thead style = "background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope = "col"> Tipo Beneficiario </th>

                            <th scope = "col"> Nivel Educacional </th>

                            <th scope = "col"> Nota Corte </th>

                            <th scope = "col"> Cupos </th>

                            <th scope = "col"> N° Postulaciones </th>

                            <th scope = "col"> Cupo Disponible </th>

                            <th scope = "col"> Monto </th>

                            <th scope = "col"> Presupuesto   </th>

                            <th scope = "col"> Presupuesto Libre </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr class = "tablaPostulaciones" *ngFor = "let curso of cursosExcelencia ; let i = index">

                            <td> {{curso.postulaAfiliado ? 'Afiliado' : 'Carga'}} </td>

                            <td> {{curso.descripcion}} </td>

                            <td> {{curso.calificacionMinima}} </td>

                            <td> <input [(ngModel)] = "cursosExcelencia[i].cupoTotal" class = "form-control"
                            value = "{{curso.cupoTotal}}" [disabled] = "!editaCupos"> </td>

                            <td> {{curso.postulaciones}} </td>

                            <td> {{curso.cupoTotal - curso.postulaciones}} </td>

                            <td> {{curso.monto  | currency:'CLP':'symbol-narrow' }} </td>

                            <td> {{curso.monto * curso.cupoTotal  | currency:'CLP':'symbol-narrow' }} </td>

                            <td> {{(curso.monto * curso.cupoTotal) - (curso.monto * curso.postulaciones) | currency:'CLP':'symbol-narrow' }} </td>

                        </tr>

                    </tbody>

                </table> <br/>

            </div>

            <div class = "row">

                <div class = "col-lg-4"> <h3> Necesidades Especiales </h3> </div>

                <div class = "col-lg-8"> </div>

            </div>

            <div class = "table-responsive">

                <table class = "table">

                    <thead style = "background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope = "col"> Tipo Beneficiario </th>

                            <th scope = "col"> Nivel Educacional </th>

                            <th scope = "col"> Cupos </th>

                            <th scope = "col"> N° Postulaciones </th>

                            <th scope = "col"> Cupo Disponible </th>

                            <th scope = "col"> Monto </th>

                            <th scope = "col"> Presupuesto </th>

                            <th scope = "col"> Presupuesto Libre </th>
                        </tr>

                    </thead>

                   <tbody>

                        <tr class = "tablaPostulaciones" *ngFor = "let curso of cursosNecesidades ; let i = index">

                            <td> {{curso.postulaAfiliado ? 'Afiliado' : 'Carga'}} </td>

                            <td> {{curso.descripcion}} </td>

                            <td> <input [(ngModel)] = "cursosNecesidades[i].cupoTotal" class = "form-control"
                            value = "{{curso.cupoTotal}}" [disabled] = "!editaCupos"> </td>

                            <td> {{curso.postulaciones}} </td>

                            <td> {{curso.cupoTotal - curso.postulaciones}} </td>

                            <td> {{curso.monto  | currency:'CLP':'symbol-narrow' }} </td>

                            <td> {{curso.monto * curso.cupoTotal  | currency:'CLP':'symbol-narrow' }} </td>

                            <td> {{(curso.monto * curso.cupoTotal) - (curso.monto * curso.postulaciones)  | currency:'CLP':'symbol-narrow' }} </td>

                        </tr>

                    </tbody>

                </table> <br/>

            </div>

            <div class = "row">

                <div class = "col-lg-4" style = "text-align: center" *ngIf = "!editaCupos">

                    <button *ngIf = "!rankingAprobado" class = "btn btn-warning" (click) = "editaCupos = true"> <i class = "fas fa-edit"> </i> Editar Cupos </button>

                </div>

                <div class = "col-lg-4" style = "text-align: center" *ngIf = "editaCupos">

                    <button *ngIf = "!rankingAprobado" class = "btn btn-info" (click) = "modificarCupos()"> Modificar Cupos </button>

                </div>

                <div class = "col-lg-4" style = "text-align: center">

                    <button *ngIf = "!rankingAprobado" class = "btn btn-success" (click) = "openDialog()"> <i class = "fas fa-check"> </i> Aprobar Ranking </button>

                </div>

                <div class = "col-lg-4" style = "text-align: center">

                    <button *ngIf = "!rankingAprobado" class = "btn btn-info" (click) = "descargaCsv()"> <i class = "fas fa-download"> </i> Descarga Pre Aprobación Ranking </button>

                </div>

                <div class = "col-lg-4" style = "text-align: center">

                    <button *ngIf = "rankingAprobado" class = "btn btn-info" (click) = "descargaCsvResultado()"> <i class = "fas fa-download"> </i> Descarga Resultado Ranking </button>

                </div>

            </div>

        </div>

        <div class = "container" style = "height:100px"> </div>

    </div>

</div>
